<template>
  <mds-tr class="custom-table__row" @click.native="$emit('clickedRow', record)">
    <mds-td class="custom-table__column">{{ record.name }}</mds-td>
    <mds-td class="custom-table__column">{{ record.id }}</mds-td>
    <mds-td class="custom-table__column">{{ record.source }}</mds-td>
    <mds-td class="custom-table__column">
      <div>{{ record.lastUpdate.date }}</div>
      <div v-show="record.lastUpdate.date !== '—'" class="custom-table__time">
        {{ lastUpdateDate }}
      </div>
    </mds-td>

    <mds-td class="custom-table__column">
      <CustomTableActions
        :record="record"
        :rowId="record.id"
        :actions="actions"
        v-on="$listeners"
      />
    </mds-td>
  </mds-tr>
</template>

<script>
import { MdsTr, MdsTd } from '@mds/data-table'
import CustomTableActions from './CustomTableActions.vue'
export default {
  name: 'CustomTableRowFeed',
  components: {
    MdsTr,
    MdsTd,
    CustomTableActions,
  },
  props: {
    record: {
      type: Object,
      default: () => ({}),
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    lastUpdateDate() {
      const { lastUpdate } = this.record
      return `${lastUpdate.time} ${lastUpdate.timezone} (${lastUpdate.utcOffset})`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.custom-table {
  &__row:hover {
    background-color: $mds-color-neutral-90;
  }
  &__row {
    cursor: pointer;
    height: $mds-space-8-x;

    &:first-child {
      .custom-table__column {
        border-top: none;
      }
    }

    &:nth-child(even):hover {
      background-color: $mds-color-neutral-90;
    }
    &:nth-child(even) {
      background-color: $mds-background-color-light-gray;
    }
  }

  &__column {
    @include mds-body-text-s();
    vertical-align: middle;
    padding-left: $mds-space-1-x;
  }

  &__time {
    color: $mds-color-neutral-37;
  }
}
</style>
